import { QuestionnaireState } from '@/types/store'
import { GetQuestionnairesResponse } from '../../../api/@types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<QuestionnaireState> = {
  setIsQuestionnaireLoading(state, isLoading: boolean) {
    state.isQuestionnaireLoading = isLoading
  },
  questionnaireLoaded(state, questionnaires: GetQuestionnairesResponse[]) {
    state.questionnaires = questionnaires
  },
  deleteQuestionnaire(state, questionnaire: GetQuestionnairesResponse) {
    state.questionnaires = state.questionnaires.filter(
      q => q.id !== questionnaire.id,
    )
  },
  setQuestionnaire(state, questionnaire: GetQuestionnairesResponse) {
    state.questionnaire = questionnaire
  },
  setCompletionQuestionnaires(
    state,
    questionnaires: GetQuestionnairesResponse[],
  ) {
    state.completeQuestionnaires = questionnaires
  },
}
